import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getGalleryImage, updateGalleryImage } from "adminApi/GalleryApi/Gallery";
import { validateForm } from "utils/validation";
import { GalleryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditGalleryForm from "./Componates/EditGalleryForm";
import fields from "../json/GalleryFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditGallery = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Default initial form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  // Form state management
  const { values, errors, handleChange, handleFileChange, setValues, setErrors } = useFormChange(
    initialValues,
    GalleryRules
  );

  // Fetch existing gallery data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    getGalleryImage,
    setValues
  );

  // Form submission
  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        if (key !== "imagePreview") formData.append(key, val ?? "");
      });
      return await updateGalleryImage({ id, data: formData });
    },
    (vals) => {
      const temp = { ...vals };
      if (typeof temp.image === "string") delete temp.image;
      delete temp.imagePreview;
      const err = validateForm(temp, GalleryRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Gallery updated successfully"
  );

  return (
    <>
      {(loading || loadingFetch) && <Spinner isSpinner={true} />}
      <EditGalleryForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={values.imagePreview || (values.image ? values.image : "")}
        loading={loading}
        title="Update Gallery"
      />
    </>
  );
};

export default EditGallery;
